import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IMeetingCostListPayload } from '@app-store/slices/meetings/meetingCostList'

interface TaskAction extends Action {
    payload: IMeetingCostListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetings.meetingCostList

function* meetingCostListSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/meeting/costs`, {
            params
        })
        if (response.success) {
            yield put(onSuccess({ noSaveInStore: payload.noSaveInStore, ...response.result }))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* meetingCostListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, meetingCostListSagaTask)
}

export default meetingCostListSaga
